module.exports = __webpack_public_path__ + "img/overall-right-answers.db59eba7.svg";